import { apiFinancialsList } from "api/financialApi";
import ImgLogoBank from "../assets/svg/ImgLogoBank.svg";
import { apiAddPosAction, apiGeFunctiontPos, apiUpdatePos } from "api/PosApi";
import { store } from "store/store";
const dispatch = store.dispatch
export const posSettingFormData = {
    key: "bank",
    title: "حساب",
    addFunction: apiAddPosAction,
    getFunction: apiGeFunctiontPos,
    updateFunction: apiUpdatePos,
    navigation: {
        title: "افزودن دستگاه کارت خوان",
        backTitle: "بازگشت",
        backUrl: "/financials",
    },
    summaryInfo: {
        key: "pos",
        primaryTitleKey: "name",
        addTempTitle: "افزودن دستگاه کارت خوان جدید",
        saveTitle: "ذخیره دستگاه کارت خوان",
        defaultImage: ImgLogoBank,
    },
    tabs: [
        {
            key: "posSetting",
            name: "دستگاه کارتخوان",
            form: {
                main: {
                    wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
                    imagePicker: {
                        active: false,
                    },

                    inputs: [
                        {
                            wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12 offset-1 offset-xs-0",
                            type: "selectBox",
                            addModal: {
                                props: {
                                    component: "financial",
                                    title: false,
                                    closeButton: false,
                                    onFinish: (token) => apiFinancialsList("bank", token),
                                },
                            },
                            style: {
                                paddingRight: "60px",
                                paddingLeft: "50px",
                            },
                            name: "FinancialId",
                            label: "بانک",
                            primary: true,
                            showInput: true,
                            required: true,
                            options: "banks",
                        },

                        {
                            wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
                            outerWrapperClass: "col-lg-5 col-md-5 col-sm-5 col-xs-12",
                            active: true,
                            type: "radioInput",
                            name: "default",
                            label: "پیش فرض",
                            options: [
                                {
                                    title: "بله",
                                    value: 1,
                                },
                                {
                                    title: "خیر",
                                    value: 0,
                                },
                            ],
                        },


                        {
                            wrapperClass: "col-lg-7 col-md-7 col-sm-7 col-xs-12",
                            name: "title",
                            label: "عنوان دستگاه کارت خوان",
                            required: true,
                            primary: true,
                            maxLength: 32,
                            style: {
                                paddingRight: "60px",
                                paddingLeft: "50px",
                            },
                        },
                        {
                            wrapperClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5",
                            name: "ip",
                            type: "number",

                            showInput: false,
                            primary: true,
                            label: "آدرس IP",
                            style: {
                                paddingRight: "60px",
                            },
                        },
                        {

                            wrapperClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7 pr-[60px] pl-[50px]",
                            type: "selectBox",
                            name: "type",
                            label: "نوع اتصال",
                            showInput: true,
                            primary: true,
                            options: [
                                {
                                    id: "TCP",
                                    title: `TCP`,
                                    label: 'TCP',
                                    value: 'TCP'
                                },
                                // {
                                //     id: "Serial",
                                //     title: `Serial`,
                                //     label: 'Serial',
                                //     value: 'Serial'
                                // }
                            ],
                            onChange: (dispatch, value) => {

                            },
                            style: {
                                paddingRight: "60px",
                            },
                        },
                        {
                            wrapperClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5",
                            name: "port",
                            type: "number",
                            primary: true,
                            parseInt: true,
                            maxLength: 4,
                            showInput: false,
                            label: "پورت",
                            style: {
                                paddingRight: "60px",
                            },
                        },
                        {
                            name: "description",
                            label: "توضیحات",
                            primary: true,
                            wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 style-padding-inputs",
                            style: {
                                paddingRight: "60px",
                            },
                        },
                    ],

                },
            },
        },
    ]

}